<template>
    <v-dialog persistent v-model="dialog" width="55%">
        <v-card>
            <v-container>
                <div class="testpage">
                    <h3 class="ml-1">{{this.title}}</h3>
                    <div class="br_medium"></div>
                    <v-row cols="12" v-resize="onResize" dense no-gutter>
                        <v-col cols="12">
                            <v-expansion-panels flat v-model="panel">
                                <v-expansion-panel expand v-model="panel" class='ma-1'>
                                    <v-expansion-panel-header>
                                        <v-row cols="12">
                                            <div v-if="this.files_uploaded.length > 0">
                                                <h4 class="ml-5 has_elements" style="display: none;">Uploaded: {{ this.files_uploaded.length }}</h4>
                                         
                                            </div>
                                            <div v-else>
                                                <h4 class="ml-5 no_elements" style="display: none;">Uploaded:<span> (no files uploaded)</span></h4>
                                            </div>
                                        </v-row>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content min-width="100%">
                                        <div v-if="this.files_uploaded.length > 0">
                                            <v-data-table :headers="getAttachmentHeaders('top')" 
                                                        :items="files_uploaded" 
                                                        :disable-pagination=true hide-default-footer item-key="key" dense>
                                                <template v-slot:body="{ items }">
                                                    <tbody>
                                                        <tr v-for="(item, idx) in items" :key="idx">
                                                            <td>{{ item.description }}</td>
                                                            <td>{{ item.internal_type }}</td>
                                                            <td>{{ item.uploaded }}</td>
                                                            <td>{{ item.uploadedByName }}</td>
                                                            <td>{{ bytesToSize(item.size) }}</td>
                                                            <td>{{ item.extension }}</td>
                                                            <td>
                                                                <div v-if="!item.isloading" @mouseover="showAttmImageOnHover(item)">

                                                                    <v-tooltip left>
                                                                        <template v-slot:activator="{ on }">
                                                                            <v-btn icon small v-on:click="getPreviewFromServer(item, true)" v-on="on">
                                                                                <v-icon>mdi-card-search-outline</v-icon>
                                                                            </v-btn>
                                                                        </template>
                                                                        <span>
                                                                            <img :src="attmImgUrl" width="300" height="250"/>
                                                                        </span>
                                                                    </v-tooltip>

                                                                   
                                                                    

                                                                </div>
                                                                <div v-else>
                                                                    <v-progress-circular :width="3" :size="20" color="green" indeterminate></v-progress-circular>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div v-if="!item.isremoving">
                                                                    <v-btn icon small v-on:click="deleteRemoteItem(item)">
                                                                        <v-icon>mdi-trash-can-outline</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                                <div v-else>
                                                                    <v-progress-circular :width="3" :size="20" color="red" indeterminate></v-progress-circular>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-data-table>
                                        </div>
                                        <div v-else>
                                            <p class="ml-5">no files uploaded</p>
                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>                    
                    <v-row cols="12" v-resize="onResize" dense no-gutter>
                        <v-col cols="12">
                            <v-card flat>
                                <v-container>
                                    <v-row dense>
                                        <v-col cols="11">
                                            <template>
                                                <v-file-input v-model="files" color="primary accent-4" counter
                                                    label="Select your files here" multiple hint=""
                                                    prepend-icon="mdi-paperclip" :show-size="1000" class="ma-4"
                                                    v-on:click:clear="callClear()" v-on:change="callChange()">
                                                    <template v-slot:selection="{ index, text }">
                                                        <v-chip v-if="index < 6" color="primary accent-3" light label
                                                            small>
                                                            {{text}}
                                                        </v-chip>
                                                        <span v-else-if="index === 6" class="text-overline grey--text text--darken-3 mx-2">
                                                            +{{files.length - 6}} File(s)
                                                        </span>
                                                    </template>
                                                </v-file-input>
                                            </template>
                                        </v-col>
                                        <v-col cols="1">
                                            <v-btn small fab
                                                v-bind:disabled="!files_ok || !success_ok || !description_ok || illegal_chars || loading || !descriptions_unique"
                                                v-bind:loading="loading"
                                                class="success white--text fab-margin"
                                                v-on:click="processFiles()">
                                                <v-icon>mdi-upload</v-icon>
                                                <template v-slot:loader>
                                                    <span class="custom-loader">
                                                        <v-icon light>mdi-cached</v-icon>
                                                    </span>
                                                </template>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row cols="12" v-resize="onResize" dense no-gutter>
                        <v-col cols="12">
                            <v-card flat>
                                <v-container>
                                    <div v-if="this.files_selected.length > 0">
                                        <v-row class="flex">
                                        <h4 class="ml-5 mr-5">Selected: {{ this.files_selected.length }}</h4>
                                        <div>
                                            <div v-if="!files_ok">Select files in order to be able to upload</div>
                                            <div v-if="!description_ok"><v-icon medium color="primary" class="mr-2">mdi-information</v-icon>Complete descriptions in order to be able to upload</div>
                                            <div v-if="illegal_chars" style="color: red;"><v-icon medium color="error" class="mr-2">mdi-alert-circle</v-icon>Descriptions has characters that are not allowed ( {{ illegal_chars_list }} )</div>
                                            <div v-if="!descriptions_unique" style="color: red;"><v-icon medium color="error" class="mr-2">mdi-alert-circle</v-icon>Not all descriptions are unique. This may cause problems with mailings</div>
                                            <div v-if="files_ok && description_ok && descriptions_unique && !illegal_chars"><v-icon medium color="success" class="mr-2">mdi-check-circle</v-icon>Ready to upload {{this.files.length}} file(s)</div>                                            
                                        </div>
                                        </v-row>
                                    </div>
                                    <div v-else>
                                        <h4 class="ml-5">Selected:<span> (no files selected)</span></h4>
                                    </div>
                                    <br>
                                    <div v-if="this.files_selected.length > 0">
                                        <v-data-table :headers="getAttachmentHeaders('bottom')" :items="files_selected"
                                            :disable-pagination=true item-key="key" dense hide-default-footer>
                                            <template v-slot:body="{ items }">
                                                <tbody>
                                                    <tr v-for="(item, idx) in items" :key="idx">
                                                        <td>{{item.name}}</td>
                                                        <td class="td_markup">
                                                            <v-text-field 
                                                                prepend-icon="mdi-playlist-edit" 
                                                                v-model.lazy="item.description" 
                                                                label="Click here to enter a description" 
                                                                single-line dense></v-text-field>                                                            
                                                        </td>
                                                        <td>
                                                            <v-select v-if="AttachmentsTypeChoices.length > 0"  v-model="item.internal_type" :items="AttachmentsTypeChoices" item-text="label" item-value="value" label="Select a type" dense></v-select>
                                                            <span v-else style="color:#bbb"><i>no document types available</i></span>
                                                        </td>
                                                        <td>{{item.conv_size}}</td>
                                                        <td>{{item.extension}}</td>
                                                        <td>
                                                            <div v-if="!item.success">
                                                                <v-tooltip top>
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-btn v-bind="attrs" v-on="on" icon small>
                                                                            <v-icon color="red">mdi-alert-outline</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>{{item.result_message}}</span>
                                                                </v-tooltip>
                                                            </div>
                                                            <div v-else>
                                                                <div v-if="!item.isloading">
                                                                    <v-btn icon small v-on:click="previewLocalFile(item)">
                                                                        <v-icon>mdi-card-search-outline</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                                <div v-else>
                                                                    <v-progress-circular :width="3" :size="20" color="green" indeterminate></v-progress-circular>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div v-if="!item.isremoving">
                                                                <v-btn icon small v-on:click="deleteItem(item.name)" class="ml-2">
                                                                    <v-icon>mdi-trash-can-outline</v-icon>
                                                                </v-btn>
                                                            </div>
                                                            <div v-else>
                                                                <v-progress-circular :width="3" :size="20" color="red" indeterminate></v-progress-circular>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-data-table>
                                    </div>
                                    <div v-else>
                                        <p class="ml-8">no files selected</p>
                                    </div>
                                </v-container>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small v-on:click="closeDialog()">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    import mxfindwithattribute from '@/mixins/findwithattribute';
    import mxbytestosize from '@/mixins/bytestosize';
    import {bus} from "../main";    

    export default {
        mixins:[mxfindwithattribute, mxbytestosize],
        computed:{
            current_size: function(){
                return this.$vuetify.breakpoint.name;
            },
            files_ok: function () {
                return this.files.length > 0
            },
            illegal_chars: function(){
                let ret_val = false;
                if (this.files.length > 0) {
                    this.files_selected.forEach((element) => {
                        for (let i in element.description){                        
                            if (this.illegalChars.includes(element.description[i].charCodeAt(0))){                              
                                ret_val = true;
                            }
                        }
                    });
                }
                return ret_val;
            },
            descriptions_unique: function(){
                let ret_val = true;
                this.files_selected.forEach((element) => {
                    let desc = element.description;    
                    let key = element.key;       
                    console.log('desc', desc,'key', key);
                    if(desc!==null && desc !==''){
                        this.files_selected.forEach((el) => {
                            console.log(el.description, desc)
                            if(el.description!==null && el.description===desc && el.key!==key){
                                ret_val=false;
                            }
                        })
                    }
                });
                if(ret_val===true){
                    this.files_uploaded.forEach((element) => {
                        let desc = element.description;
                        this.files_selected.forEach((el) => {
                            if(el.description===desc){
                                ret_val=false;
                            }
                        })                        
                    })
                }
                return ret_val;
            },
            illegal_chars_list: function() {
                return String.fromCharCode(...this.illegalChars);
            },
            description_ok: function(){
                if (this.files.length > 0) {
                    var ret_val=true;
                    this.files_selected.forEach((element) => {
                        if (element.description === '' || element.description === null) {
                            ret_val=false;
                        }
                    });
                } else {
                    ret_val=false;
                }       
                return ret_val;     
            },
            success_ok: function(){
                if (this.files.length > 0) {
                    var ret_val=true;
                    this.files_selected.forEach((element) => {
                        if (element.success === false) {
                            ret_val=false;
                        }
                    });
                } else {
                    ret_val=false;
                }       
                return ret_val;     
            }                           
        },       
        data() {
            return {
                name: 'test multi file upload',
                remove_base64metadata: false,
                files_selected: [],
                numberOfFiles: 0,
                numberOfFilesSent: 0,
                dialog: false,
                loading: false,
                parent: '',
                table: '',
                key1: '',
                key2: '',
                title: '', 
                encrid: '',
                attm: {},              
                files: [], // immutable array
                files_uploaded: [],
                preview: {},   
                attmImgUrl: '', 
                panel: null,
                illegalChars: [33,34,35,36,37,38,39,40,41,42,43,47,58,60,61,62,63,64,96,123,124,125],
                AttachmentsTypeChoices: [],
            }
        },
        methods: {
            open(table,key1,key2,parent,encrid,panel) {    
                console.log('m_attm open');            
                this.dialog = true;
                this.parent = parent;
                this.panel = panel;
                this.files = [];
                this.files_selected = [];
                this.preview = {};
                this.numberOfFiles = 0;
                this.numberOfFilesSent = 0;
                this.loading = false;
                switch(table){
                    case 'hosm':
                        this.title = "Attachment(s) claim " + key1;
                        break;
                    case 'hokl':
                        this.title = "Attachment(s) complaint " + key1;
                        break;                        
                    case 'homb':
                        this.title = "Attachment(s) rebooking " + key1;
                        break;
                    case 'howz':
                        this.title = "Attachment(s) change " + key1;
                        break;
                    case 'huov':
                        this.title = "Attachment(s) rental agreement " + key1;
                        break;
                    case 'pten':
                        this.title = "Attachment(s) lead " + key1;
                        break;
                    default:
                        this.title = "Attachment(s) " + key1;
                        break;
                }
                this.attm = {
                    table: table, 
                    encrid: encrid, 
                    key1: key1, 
                    key2: key2,
                };          
                this.getFileListFromServer();   
            },      
            closeDialog(){
                switch(this.parent){
                    case "huov":
                        console.log("sender: dispatch event for update attm on huov");
                        bus.$emit("closeDialog", "huov_m_attm");
                        break;
                    case "hosm":
                        console.log("sender: dispatch event for update attm on hosm");
                        bus.$emit("closeDialog", "hosm_m_attm");    
                        break;
                    case "homb":
                        console.log("sender: dispatch event for update attm on homb");
                        bus.$emit("closeDialog", "homb_m_attm");    
                        break;
                    case "howz":
                        console.log("sender: dispatch event for update attm on howz");
                        bus.$emit("closeDialog", "howz_m_attm");    
                        break;
                    case "pten":
                        console.log("sender: dispatch event for update attm on pten");
                        // bus.$emit("closeDialog", "howz_m_attm");    
                        break;
                    case "openai":
                        console.log("sender: dispatch event for update attm on openai");
                        // bus.$emit("closeDialog", "howz_m_attm");    
                        break;
                    default:
                        console.log("sender: dispatch event for update attm on undisclosed parent");
                        bus.$emit("closeDialog", "attm_m_attm");   
                }
                console.log('m_attm', 'send updateData');
                this.$emit('updateData', this.parent);
                this.$emit('updateNumberOfAttm', this.files_uploaded.length);
                this.dialog = false;
            },            
            callClear(){
                // this will call 'change' event
            },        
            previewLocalFile(item){
                /* this gave an error (white screen) with larger files (> 1,5 mb)
                var win = window.open();
                win.document.write('<iframe src="' + data_url  + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
                win.document.close();
                */
                item.isloading=true;
                const base64ImageData = item.content;
                const contentType = item.mimetype;
                const byteCharacters = window.atob(base64ImageData.substr(`data:${contentType};base64,`.length));
                const byteArrays = [];
                for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
                    const slice = byteCharacters.slice(offset, offset + 1024); // chunks
                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }
                const blob = new Blob(byteArrays, {type: contentType});
                const blobUrl = URL.createObjectURL(blob);
                window.open(blobUrl, '_blank');
                item.isloading=false;
            },          
            sendFileToServer(element) {
                console.log(element);
                this.$axios
                    .post("ares/json/ares/misc/saveAttachment.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "saveAttachment"
                        },
                        saveAttachment: {
                            table: this.attm.table,
                            encrid: this.attm.encrid,
                            name: element.name,
                            conv_size: element.conv_size,
                            internal_type: element.internal_type,
                            mimetype: element.mimetype,
                            extension: element.extension,
                            key: element.key,
                            description: element.description,
                            content: element.content,
                        }
                        })
                        .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                            this.loading = false; // stop spinning on error
                        } else {
                            try{
                                if(res.data.saveAttachment.attachment.success){
                                    this.files_uploaded.push(res.data.saveAttachment.attachment);
                                    this.deleteItem(res.data.saveAttachment.attachment.name);
                                } else {
                                    var idx = this.findWithAttr(this.files_selected, "name", res.data.saveAttachment.attachment.name);
                                    this.files_selected[idx].success = res.data.saveAttachment.attachment.success;
                                    this.files_selected[idx].result_message = res.data.saveAttachment.attachment.result_message;
                                    idx = this.findWithAttr(this.files, "name", res.data.saveAttachment.attachment.name);
                                    this.files.splice(idx, 1);
                                }    
                                this.numberOfFilesSent += 1;
                                if(this.numberOfFiles === this.numberOfFilesSent){
                                    this.loading = false; // explicitly NOT in the finally block this call could be one of many. 
                                                        // Only after the last file (= last call) should the loader stop                   
                                }   
                            } catch(err){
                                console.log('one or more files could not be uploaded');
                                this.loading = false;  
                            }                         
                        }
                    })
                    .finally(() => {});
            },                         
            callChange() {
                this.files_selected.splice(0, this.files_selected.length); // clear the selected array
                if (this.files.length > 0) {
                    for (let i = 0; i < this.files.length; i++) {
                        this.readFileToBase64(this.files[i])
                        .then(data => {
                            // create the (rest of the) record after we have the base64 content 
                            var file_selected = new Object();
                            file_selected.content = data; // base64 encoded file, we need this for uploading                   
                            file_selected.name = this.files[i].name;
                            file_selected.key = i;
                            file_selected.description = null;
                            file_selected.conv_size = this.bytesToSize(this.files[i].size);
                            file_selected.extension = this.getFileExtension(this.files[i].name);
                            file_selected.mimetype = this.files[i].type;
                            file_selected.success = true;
                            file_selected.result_message = '';
                            file_selected.isloading = false;
                            file_selected.isremoving = false;
                            this.files_selected.push(file_selected);                            
                        })
                        .catch(error => { console.log(error) });
                    }
                }
            },    
            deleteItem(attr_value){
                var idx = this.findWithAttr(this.files_selected, "name", attr_value);
                this.files_selected.splice(idx, 1);   
                idx = this.findWithAttr(this.files, "name", attr_value);
                this.files.splice(idx, 1);
            },
            processFiles() {
                this.loading = true;
                this.numberOfFiles = this.files_selected.length;
                this.numberOfFilesSent = 0;
                for (let i = 0; i < this.files_selected.length; i++) {
                    this.sendFileToServer(this.files_selected[i]); // async
                }
            },
            getFileExtension(parameter) {
                return parameter.substring(parameter.lastIndexOf('.') + 1, parameter.length) || parameter;
            },
            getFileListFromServer() {
                this.$axios
                    .post("ares/json/ares/misc/getAttachments.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAttachments"
                    },
                    getAttachments: {
                        table: this.attm.table,
                        encrid: this.attm.encrid,
                    }})
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {                        
                            this.files_uploaded = res.data.getAttachments;                        
                            this.AttachmentsTypeChoices = res.data.AttachmentsTypeChoices;
                    }})
                    .finally(() => {
                        try{
                            this.initExpansionPanelHeader(this.files_uploaded.length);
                        } catch(err){
                            this.initExpansionPanelHeader(0);
                        }
                    });
            },     
            initExpansionPanelHeader(elements){
                const empty_items = document.querySelectorAll('.no_elements');
                const not_empty_items = document.querySelectorAll('.has_elements');
                if(elements==0) {
                    not_empty_items.forEach(item => item.style.display = 'none'); // hide: overrides current display setting 
                    empty_items.forEach(item => item.style.display = '');  // display: overrides current display setting 
                } else {
                    not_empty_items.forEach(item => item.style.display = ''); // display: overrides current display setting 
                    empty_items.forEach(item => item.style.display = 'none'); // hide: overrides current display setting 
                }
            },
            deleteRemoteItem(item) {
                item.isremoving = true;
                this.$axios
                    .post("ares/json/ares/misc/deleteAttachment.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "deleteAttachment"
                    },
                    deleteAttachment: {
                        table: this.attm.table,
                        attm_nr: item.attm_nr,
                    }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.deleteLocalItem(item.attm_nr); // pop array entry.
                    }})
                    .finally(() => {item.isremoving = false;});
            },                            
            getPreviewFromServer(item, direct_show) {
                item.isloading = true;
                this.$axios
                    .post("ares/json/ares/misc/getAttachment.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAttachment"
                    },
                    getAttachment: {
                        table: this.attm.table,
                        attm_nr: item.attm_nr,
                    }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.preview = res.data.getAttachment;
                            if(direct_show){
                                this.previewFileByUrl(this.preview.url);                                
                            }
                        }
                    })
                    .finally(() => {item.isloading = false;});
            },  
            showAttmImageOnHover(item){
                if(!this.loading){
                    this.loading = true
                    this.attmImgUrl = 'https://placehold.co/200x150?text=Loading...'
                    //console.log(item)
                    this.$axios.post("ares/json/ares/misc/getAttachment.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getAttachment"
                        },
                        getAttachment: {
                            table: this.attm.table,
                            attm_nr: item.attm_nr,
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            if(res.data.getAttachment.extension === 'png' || res.data.getAttachment.extension === 'jpg'){
                                this.attmImgUrl = res.data.getAttachment.url
                            }else{
                                this.attmImgUrl = 'https://placehold.co/200x150?text=Click+to+view'
                            }
                        }
                    })
                    .finally(() => {this.loading = false});
                }
                
            },                    
            deleteLocalItem(attr_value){
                var idx = this.findWithAttr(this.files_uploaded, "attm_nr", attr_value);
                this.files_uploaded.splice(idx, 1);   
            },                    
            onResize(){
            },       
            previewFileByUrl(url){
                window.open(url,'_blank');
            },        
            getAttachmentHeaders(arg){
                if (arg==='top'){ // uploaded
                    return [
                        { text: "Description", value: "description",  width: "30%"},
                        { text: "Document Type", value: "internal_type", width: "20%"},
                        { text: "Uploaded", value: "uploaded",width: "20%"},
                        { text: "Uploaded by", value: "uploadedByName",width: "20%"},
                        { text: "Size", value: "conv_size", width: "15%"},
                        { text: "Type", value: "extension", width: "10%"},
                        { text: "", width: "5%", sortable: false},
                        { text: "", width: "5%", sortable: false},
                    ];    
                } else { // selected for upload
                    return [
                        { text: "Name", value: "name", width: "20%"},
                        { text: "Description", value: "description",  width: "30%"},
                        { text: "Document Type", value: "internal_type", width: "20%"},
                        { text: "Size", value: "conv_size", width: "10%"},
                        { text: "Type", value: "extension", width: "10%"},
                        { text: "", width: "5%", sortable: false},
                        { text: "", width: "5%", sortable: false},
                    ];    
                }
            },                            
            save_item() { },
            cancel_item() { },
            open_item() { },
            close_item() { },
            readFileToBase64(element) {
                return new Promise((resolve, reject) => {
                    var reader = new FileReader();
                    reader.readAsDataURL(element);
                    reader.onload = () => {
                        let encoded;
                        try {
                            if (this.remove_base64metadata == true) {
                                encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
                                if ((encoded.length % 4) > 0) {
                                    encoded += '='.repeat(4 - (encoded.length % 4));
                                }
                            } else {
                                encoded = reader.result.toString();            
                            }
                            resolve(encoded);
                        } catch (error) {
                            reject(error);
                        }
                    }
                });
            }
        },                
    }
</script>


<style scoped>
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }
    @-moz-keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(360deg);}
    }
    @-webkit-keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(360deg);}
    }
    @-o-keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(360deg);}
    }
    @keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(360deg);}
    }  
    .fab-margin {
        margin-top: 40px;
        margin-bottom: 0px;
    }
    .br_medium {
      display: block;
      margin-bottom: 1em;
    }    
    .td_markup {
        vertical-align: top;
        border-top: 6px solid transparent;
        /* trick to add padding to a TD element (which is not possible with CSS normally) */
    }    
    .flex{
        display: flex;
        flex-direction: row;
        align-items: center;
    }
</style>